// --------------------------------------------------------------------------
// showTicketQty.js
// --------------------------------------------------------------------------
// Toggle the visibility of ticket quantity fields
// --------------------------------------------------------------------------

RN.showTicketQty = function() {

  'use strict';

  var checkoutButton = byElement('enable-checkout');

  function init() {
    byBehaviour('show-ticket-qty').on('change', toggleTicket);
    byElement('additional-tickets').on('change', function(){
      handleTicketTypes($(this));
    });
  }

  function handleTicketTypes(wrapper) {
    var inputs = wrapper.find('input');

    if(!(wrapper.hasClass('exhibit-listing-with-tickets__tickets--is-hidden'))){
      inputs.each(function(){
          if(this.value > parseInt(checkoutButton.attr('data-min-selected'))){
              checkoutButton.prop('disabled', false);
              return false;
          }
          else{
              checkoutButton.prop('disabled', true);
          }
      });
    }
    else {
      checkoutButton.prop('disabled', false);
    }

  }

  function toggleTicket (){
    var ticketListing = $(this).closest('.exhibit-listing-with-tickets').find('.exhibit-listing-with-tickets__tickets');

    ticketListing.toggleClass('exhibit-listing-with-tickets__tickets--is-hidden');

    handleTicketTypes(ticketListing);
  }

  return {
    init: init
  };

}();